import { notificationActionTypes, NOTIFICATION_TYPES } from './notification.types'
import http from '../../services/http';
import { mensagemDeChatEncerrado, tituloDoChatEncerrado } from '../../utils/avisoDeChatEncerrado';

export const setNotificationCount = (count, roomid, old) => {
  return {
    type: notificationActionTypes.SET_NOTIFICATION_COUNT,
    payload: count,
    roomId: roomid,
    oldMessage: old
  }
}

export const selectCount = state => state.notification.count

export const selectMsg = state => state.notification.messages

export const selectOld = state => state.notification.oldMessage

export const selectRoomId = state => state.notification.rooms

// Novos seletores para notificações
export const selectNotifications = state => state.notification.notifications
export const selectUnreadCount = state => state.notification.unreadCount

export const setMessage = (message) => {
  return {
    type: notificationActionTypes.SET_MESSAGE,
    payload: message
  }
}

export const getMessage = (roomId) => {
  return async dispatch => {
    try {
      const response = await http.get(`/messages/${roomId}`);
      dispatch(setMessage(response.data));
    } catch (err) {
      console.log(err);
    }
  };
};

export const setRoomId = (roomId) => {
  return {
    type: notificationActionTypes.SET_ROOMID,
    payload: roomId
  }
}

// Actions para carregar notificações da API
export const fetchNotifications = () => {
  return async dispatch => {
    try {
      const response = await http.get('/notifications/all');
      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.SET_NOTIFICATIONS,
          payload: response.data.data
        });
      }
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
    }
  };
};

export const fetchUnreadNotifications = () => {
  return async dispatch => {
    try {
      const response = await http.get('/notifications/unread');
      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.SET_NOTIFICATIONS,
          payload: response.data.data
        });
      }
    } catch (error) {
      console.error('Erro ao buscar notificações não lidas:', error);
    }
  };
};

export const fetchUnreadCount = () => {
  return async dispatch => {
    try {
      const response = await http.get('/notifications/count');
      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.SET_UNREAD_COUNT,
          payload: response.data.data.unread_count
        });
      }
    } catch (error) {
      console.error('Erro ao buscar contagem de notificações:', error);
    }
  };
};

// Novas actions para notificações com integração à API
export const addNotification = (type, title, message, roomId = null, metadata = {}) => {
  return async dispatch => {
    try {
      const notificationData = {
        type,
        title,
        message,
        room_id: roomId,
        metadata
      };

      const response = await http.post('/notifications', notificationData);

      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.ADD_NOTIFICATION,
          payload: response.data.data
        });

        // Atualizar contagem de não lidas
        dispatch(fetchUnreadCount());
      }
    } catch (error) {
      console.error('Erro ao criar notificação:', error);
      // Fallback: adicionar apenas no estado local se a API falhar
      dispatch({
        type: notificationActionTypes.ADD_NOTIFICATION,
        payload: {
          id: Date.now(), // ID temporário
          type,
          title,
          message,
          room_id: roomId,
          is_read: false,
          data: metadata,
          created_at: new Date().toISOString()
        }
      });
    }
  };
};

// Nova action para criar notificações compartilhadas
export const addSharedNotification = (type, title, message, userIds, metadata = {}) => {
  return async dispatch => {
    try {
      const userIdsArray = Array.isArray(userIds)
        ? userIds
        : (userIds != null && userIds !== '' ? [Number(userIds)] : []);

      const notificationData = {
        type,
        title,
        message,
        user_ids: userIdsArray,
        metadata
      };

      const response = await http.post('/notifications/shared', notificationData);

      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.ADD_NOTIFICATION,
          payload: response.data.data
        });

        // Atualizar contagem de não lidas
        dispatch(fetchUnreadCount());
      }
    } catch (error) {
      console.error('Erro ao criar notificação compartilhada:', error);
    }
  };
};

// Nova action para criar anúncios
export const addAnnouncement = (type, title, message, metadata = {}) => {
  return async dispatch => {
    try {
      const notificationData = {
        type,
        title,
        message,
        metadata
      };

      const response = await http.post('/notifications/announcement', notificationData);

      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.ADD_NOTIFICATION,
          payload: response.data.data
        });

        // Atualizar contagem de não lidas
        dispatch(fetchUnreadCount());
      }
    } catch (error) {
      console.error('Erro ao criar anúncio:', error);
    }
  };
};

export const markAsRead = (notificationId) => {
  return async dispatch => {
    try {
      const response = await http.put(`/notifications/${notificationId}/read`);

      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.MARK_AS_READ,
          payload: notificationId
        });

        // Atualizar contagem de não lidas
        dispatch(fetchUnreadCount());
      }
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
    }
  };
};

export const clearNotification = (notificationId) => {
  return async dispatch => {
    try {
      const response = await http.delete(`/notifications/${notificationId}`);

      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.CLEAR_NOTIFICATION,
          payload: notificationId
        });

        // Atualizar contagem de não lidas
        dispatch(fetchUnreadCount());
      }
    } catch (error) {
      console.error('Erro ao deletar notificação:', error);
    }
  };
};

export const clearAllNotifications = () => {
  return async dispatch => {
    try {
      const response = await http.delete('/notifications/clean-old');

      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.CLEAR_ALL
        });

        // Recarregar notificações
        dispatch(fetchNotifications());
        dispatch(fetchUnreadCount());
      }
    } catch (error) {
      console.error('Erro ao limpar notificações:', error);
    }
  };
};

export const markAllAsRead = () => {
  return async dispatch => {
    try {
      const response = await http.put('/notifications/mark-all-read');

      if (response.data.success) {
        dispatch({
          type: notificationActionTypes.MARK_ALL_AS_READ
        });

        // Atualizar contagem de não lidas
        dispatch(fetchUnreadCount());
      }
    } catch (error) {
      console.error('Erro ao marcar todas as notificações como lidas:', error);
    }
  };
};

// Funções específicas para cada tipo de notificação
export const notifyNewMessage = (roomId, message, senderName = null, messageId = null) => {
  const metadata = {
    sender_name: senderName,
    message_id: messageId
  };
  return addNotification(NOTIFICATION_TYPES.NEW_MESSAGE, 'Nova mensagem', message, roomId, metadata);
};

export const notifyNewClient = (clientName, roomId = null) => {
  const metadata = {
    client_name: clientName
  };
  return addNotification(NOTIFICATION_TYPES.NEW_CLIENT, 'Novo cliente em espera', clientName, roomId, metadata);
};

export const notifyFileReceived = (roomId, fileName, senderName = null) => {
  const metadata = {
    file_name: fileName,
    sender_name: senderName
  };
  return addNotification(NOTIFICATION_TYPES.FILE_RECEIVED, 'Novo arquivo', fileName, roomId, metadata);
};

export const notifyTransfer = (fromName, roomId = null) => {
  const metadata = {
    from_name: fromName
  };
  return addNotification(NOTIFICATION_TYPES.TRANSFER, 'Conversa transferida', `Transferida de ${fromName}`, roomId, metadata);
};

export const notifySystem = (title, message, metadata = {}) => {
  return addNotification(NOTIFICATION_TYPES.SYSTEM, title, message, null, metadata);
};

// Novas funções para notificações compartilhadas
export const notifyPostMention = (postId, postTitle, mentionedBy, userIds) => {
  const metadata = {
    post_id: postId,
    post_title: postTitle,
    mentioned_by: mentionedBy
  };
  return addSharedNotification(
    NOTIFICATION_TYPES.POST_MENTION,
    'Você foi mencionado',
    `${mentionedBy} mencionou você no post "${postTitle}"`,
    userIds,
    metadata
  );
};

export const notifyTeamNewClient = (clientName, roomId, teamUserIds) => {
  const metadata = {
    client_name: clientName,
    room_id: roomId
  };
  return addSharedNotification(
    NOTIFICATION_TYPES.NEW_CLIENT,
    'Novo cliente',
    `Cliente "${clientName}" iniciou um chat`,
    teamUserIds,
    metadata
  );
};

export const notifyMaintenance = (title, message, priority = 'medium') => {
  const metadata = {
    priority,
    maintenance_date: new Date().toISOString().split('T')[0]
  };
  return addAnnouncement(
    NOTIFICATION_TYPES.SYSTEM_ANNOUNCEMENT,
    title,
    message,
    metadata
  );
};

export const notifyNewTicketAssigned = (ticketId, ticketTitle, notifyUserIds, createdByName = null) => {
  const metadata = {
    ticket_id: ticketId,
    ticket_title: ticketTitle,
    created_by_name: createdByName
  };
  return addSharedNotification(NOTIFICATION_TYPES.NEW_TICKET_ASSIGNED, 'Novo ticket atribuído', `Você foi atribuído ao ticket: "${ticketTitle}"`, notifyUserIds, metadata);
};

/**
 * O aviso de que o cliente encerrou o chat.
 *
 * `ticketNumber` e `clientCode` entraram em 02/11/2026, a pedido dele: o aviso
 * dizia "um ticket foi gerado" sem dizer QUAL, e o operador tinha de procurar
 * na listagem o chamado que já estava na mão dele. O texto mora em
 * `utils/avisoDeChatEncerrado` porque a mesma frase aparece no sininho, no
 * toast e na notificação do navegador.
 *
 * `ticket_number` vai nos metadados além de no texto: é dele que o botão do
 * toast tira o rótulo ("Abrir chamado #1234"), e ler o número de volta de uma
 * frase seria frágil.
 */
/**
 * O aviso dos dois encerramentos que acontecem longe da tela do operador: o
 * que o CLIENTE faz e o que o RELÓGIO faz (inatividade).
 *
 * `motivo` decide o título e a frase. Ele é o último parâmetro e tem padrão,
 * então quem já chamava esta função continua dizendo "o cliente encerrou" --
 * e é isso que deve acontecer quando a api ainda não manda o campo.
 */
export const notifyChatClosedByClient = (
  ticketId,
  clientName,
  operatorUserId,
  ticketNumber = null,
  clientCode = null,
  motivo = null
) => {
  const metadata = {
    ticket_id: ticketId,
    ticket_number: ticketNumber,
    client_name: clientName,
    client_code: clientCode,
    motivo
  };
  const message = mensagemDeChatEncerrado({ clientName, clientCode, ticketNumber, motivo });
  return addSharedNotification(
    NOTIFICATION_TYPES.CHAT_CLOSED_BY_CLIENT,
    tituloDoChatEncerrado(motivo),
    message,
    [operatorUserId],
    metadata
  );
};

export const notifyTicketUpdated = (ticketId, ticketTitle, updatedBy, changes = {}, notifyUserIds) => {
  const metadata = {
    ticket_id: ticketId,
    ticket_title: ticketTitle,
    updated_by: updatedBy,
    changes
  };
  return addSharedNotification(NOTIFICATION_TYPES.TICKET_UPDATED, 'Ticket atualizado', `O ticket "${ticketTitle}" foi atualizado`, notifyUserIds, metadata);
};